import dayjs from 'dayjs';
import { createContext, useState } from 'react';

export const PolicyInfoHook = () => {
  const [policyName, setPolicyName] = useState('');
  const [policyEnabled, setPolicyEnabled] = useState(true);
  const [policyDescription, setPolicyDescription] = useState('');
  const [policyCreatedOn, setPolicyCreatedOn] = useState(dayjs().format('MM/DD/YYYY'));
  const [policyFormErrors, setPolicyFormErrors] = useState({ name: false, rules: false, validated: false });
  const [policyRuleParameters, setPolicyRuleParameters] = useState({ maliciousThreshold: 0 });

  return {
    policyName,
    setPolicyName,
    policyEnabled,
    setPolicyEnabled,
    policyDescription,
    setPolicyDescription,
    policyCreatedOn,
    setPolicyCreatedOn,
    policyFormErrors,
    setPolicyFormErrors,
    policyRuleParameters,
    setPolicyRuleParameters,
  };
};

export const PolicyInfoContext = createContext(undefined);
